import React, { useState } from "react";
import {
  Dialog,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import CustomText from "../../../../components/CustomText";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import toast from "react-hot-toast";

export default function MarkValidPunchModal({ open, onClose, punchId, status , onSuccess  }) {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {

       if (!comment.trim()) {
      // If comment is empty, show an error toast
      toast.error(t("unvalidatedPunches.toast.commentRequired"));
      return; // Stop further execution
    }

    if (!punchId) {
      console.error(" punchId is missing!");
      return;
    }

    const url = `${BASE_URL}/company-admins/attendance/punch/${punchId}`;
    const body = {
       reviewStatus: status,
      reviewNote: comment || "Marked as invalid manually",
    };
    const headers = {
      "Content-Type": "application/json",
      ...(decryptedToken ? { Authorization: `Bearer ${decryptedToken}` } : {}),
    };

    console.log("🔎 Final API URL:", url);
    console.log("🔑 Token exists?", !!decryptedToken);
    console.log("🔑 Headers:", headers);
    console.log("📦 Request body:", body);

    setLoading(true);
    try {
      const res = await fetch(url, {
        method: "PATCH",
        headers,
        body: JSON.stringify(body),
      });

      console.log("📡 Response status:", res.status);

      const json = await res.json().catch(() => null);
      console.log("📩 Response JSON:", json);

      if (!res.ok) {
        throw new Error(json?.message || `Failed: ${res.status}`);
      }

      toast.success(t("unvalidatedPunches.toast.punchUpdatedSuccess"));
  onClose();
      onSuccess?.(); 
    } catch (err) {
      console.error("❌ Error saving punch:", err);
      toast.error(t("unvalidatedPunches.toast.punchUpdateFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px", p: 0 } }}
    >
      <Box sx={{ p: 3 }}>
               <CustomText
            sx={{
              fontSize: 26,
              fontWeight: 600,
              color: "#2C384C",
              textAlign:"left",
              fontFamily: "Poppins, sans-serif",
            }}
            >
         {status === "REJECTED"
    ? t("attendanceDrawer.markAsInvalid")
    : t("attendanceDrawer.markAsValid")}
        </CustomText>

 <CustomText
    sx={{
      fontSize: 16,
      fontWeight: 600,
      mt:1,
      color: "#626F86C",
      mb: 0.5,
      display: "block",
      textAlign:"left"
    }}
  >
    {t("attendanceDrawer.comments")}
  </CustomText>

 <TextField
  multiline
  minRows={3}
  fullWidth
  value={comment}
  onChange={(e) => setComment(e.target.value)}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": { border: "2px solid #091E4224" },
      "&:hover fieldset": { border: "2px solid #006EC2" },
      "&.Mui-focused fieldset": { border: "2px solid #006EC2" },
      // ↓ Add font size for input/textarea
      "& textarea": {
        fontSize: "13px", // smaller text
        fontFamily: "Poppins, sans-serif",
      },
      "& input": {
        fontSize: "13px",
        fontFamily: "Poppins, sans-serif",
      },
    },
  }}
/>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
          <CustomButton
            label={t("common.cancel")}
            onClick={onClose}
            size="medium"
            sx={{
              backgroundColor: "transparent",
              color: "#2C384C",
              "&:hover": { backgroundColor: "#F4F4F4" },
            }}
          />

          <CustomButton
            onClick={handleSave}
            disabled={loading}
            size="medium"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress size={16} sx={{ color: "white" }} />
                )}
                {loading ?  t("common.save"): t("common.save")}
              </Box>
            }
            sx={{
              backgroundColor: "#006EC2",
              color: "#fff",
              fontWeight: 500,
              "&:hover": { backgroundColor: "#005bb5" },
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
}


